function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["firstZero", "prefix", "suffix", "type", "placeholder", "allowClear", "visible", "className", "width", "height", "size", "value", "defaultValue", "variant", "onEnter", "onChange", "onPaste", "onFocus", "style", "numberControl", "step"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { cn } from "../../../lib/utils";
import { EmptyIcon, EyeoffIcon, EyeonIcon, PlusIcon, ReduceIcon } from '@bfe/moly-icons';
import { css } from '@emotion/css';
import { cva } from 'class-variance-authority';
import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from "../iconbutton";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var inputVariants = cva(['color-[#121214]'], {
  variants: {
    variant: {
      default: [''],
      error: ['border-[#EF454A]', 'focus-visible:border-[#EF454A]', 'hover:outline-none hover:border-[#EF454A]']
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
var fontSizeVariable = {
  xs: ['text-[12px] font-medium leading-[18px]'],
  small: ['text-[12px] font-medium leading-[18px]'],
  medium: ['text-[16px] font-medium leading-6'],
  'x-large': ['text-[20px] leading-6 font-medium leading-7']
};
var containerVariable = {
  xs: 'h-[32px] px-[7px] rounded gap-[8px]',
  small: 'h-[40px] pl-[11px] pr-[9px]  rounded gap-[8px]',
  medium: 'h-[48px] pl-[15px] pr-[13px] rounded-lg gap-[8px]',
  'x-large': 'h-[64px] pl-[19px] pr-[17px] rounded-lg gap-[8px]'
};
var inputStyle = css("\n  &::placeholder {\n    font-weight: 400;\n  }\n  ");
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var firstZero = _ref.firstZero,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    placeholder = _ref.placeholder,
    allowClear = _ref.allowClear,
    visible = _ref.visible,
    className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    value = _ref.value,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    onEnter = _ref.onEnter,
    _onChange = _ref.onChange,
    _onPaste = _ref.onPaste,
    _onFocus = _ref.onFocus,
    style = _ref.style,
    _ref$numberControl = _ref.numberControl,
    numberControl = _ref$numberControl === void 0 ? true : _ref$numberControl,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focusStatus = _useState2[0],
    setFocusStatus = _useState2[1];
  var _useState3 = useState(value || defaultValue),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var _useState5 = useState(type === 'number' ? 'text' : type),
    _useState6 = _slicedToArray(_useState5, 2),
    inputType = _useState6[0],
    setInputType = _useState6[1];
  var decimalRef = useRef();
  useEffect(function () {
    var loadDecimal = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var decimalModule;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('decimal.js');
            case 2:
              decimalModule = _context.sent;
              decimalRef.current = decimalModule === null || decimalModule === void 0 ? void 0 : decimalModule.Decimal;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadDecimal() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (type === 'number' && !decimalRef.current) {
      loadDecimal();
    }
    if (type === 'number') {
      setInputType('text');
    } else {
      setInputType(type);
    }
  }, [type]);
  var getIconSize = function getIconSize() {
    var iconSize = size;
    if (size === 'small') {
      iconSize = 'xs';
    }
    if (['medium', 'x-large'].includes(size) || !size) {
      iconSize = 'small';
    }
    return iconSize;
  };
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    passwordVisible = _useState8[0],
    setPasswordVisible = _useState8[1];
  var onClear = function onClear() {
    setInputValue('');
    _onChange === null || _onChange === void 0 || _onChange({
      target: {
        value: ''
      }
    });
  };
  var plusHandler = function plusHandler() {
    var _decimal1$plus;
    var InputDecimal = decimalRef.current;
    var arg1 = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString()) || '0';
    var arg2 = step.toString();
    var decimal1 = new InputDecimal(arg1);
    var decimal2 = new InputDecimal(arg2);
    var result = (_decimal1$plus = decimal1.plus(decimal2)) === null || _decimal1$plus === void 0 ? void 0 : _decimal1$plus.toString();
    setInputValue(result);
    _onChange === null || _onChange === void 0 || _onChange({
      target: {
        value: result
      }
    });
  };
  var reduceHandler = function reduceHandler() {
    var _decimal1$minus;
    var InputDecimal = decimalRef.current;
    var arg1 = (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString()) || '0';
    var arg2 = step.toString();
    var decimal1 = new InputDecimal(arg1);
    var decimal2 = new InputDecimal(arg2);
    var result = (_decimal1$minus = decimal1.minus(decimal2)) === null || _decimal1$minus === void 0 ? void 0 : _decimal1$minus.toString();
    setInputValue(result);
    _onChange === null || _onChange === void 0 || _onChange({
      target: {
        value: result
      }
    });
  };
  useEffect(function () {
    var fn = function fn() {
      if (value !== undefined && (value === null || value === void 0 ? void 0 : value.toString()) !== (inputValue === null || inputValue === void 0 ? void 0 : inputValue.toString())) {
        setInputValue(value);
      }
    };
    var t = setTimeout(fn, 300);
    return function () {
      clearTimeout(t);
    };
  }, [value, inputValue]);
  var countNonZeros = function countNonZeros(str) {
    var count = 0;
    var bool = false;
    str.split('').forEach(function (v) {
      if (bool) return;
      if (v === '0') {
        count += 1;
      } else {
        bool = true;
      }
    });
    return count;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: cn('moly-input', 'relative flex items-center bg-base-bds-gray-ele-line border border-solid border-base-bds-gray-ele-line', 'transition-all ease-in-out  duration-100', 'font-IBM', {
        'shadow-input-shadow border border-solid border-brandColor-bds-brand-900-focus': focusStatus && !props.disabled,
        'hover:border hover:border-solid hover:border-brandColor-bds-brand-800-pressed': !props.disabled,
        'cursor-not-allowed  border-bds-input-disabled-border bg-base-bds-gray-ele-edge': props.disabled,
        'border-[#EF454A] focus-visible:border-[#EF454A]  hover:border-[#EF454A]': variant === 'error',
        'shadow-error-shadow': focusStatus && variant === 'error' && !props.disabled
      }, containerVariable[size], className),
      style: _objectSpread({
        width: width,
        height: height
      }, style),
      children: [prefix && /*#__PURE__*/_jsx("div", {
        className: cn(' inline-flex items-center ', fontSizeVariable[size]),
        children: prefix
      }), /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
        type: inputType,
        ref: ref,
        placeholder: placeholder,
        value: inputValue,
        onKeyPress: function onKeyPress(event) {
          var _props$onKeyPress;
          if (firstZero) {
            var keyCode = event.keyCode || event.which;
            var keyValue = String.fromCharCode(keyCode);
            // 检查输入是否为数字 0 到 9
            var isValidInput = /^[0-9]+$/.test(keyValue);
            if (!isValidInput) {
              event.preventDefault();
            }
          }
          props === null || props === void 0 || (_props$onKeyPress = props.onKeyPress) === null || _props$onKeyPress === void 0 || _props$onKeyPress.call(props, event);
        },
        onChange: function onChange(e) {
          var value = e.target.value;
          if (type === 'number') {
            // 使用正则表达式检查输入是否为正负数或小数
            var isValidInput = /^-?\d*\.?\d*$/.test(value);
            if (firstZero) {
              var _value$match;
              // let text = "今天是2023年6月8日,气温是25.5摄氏度,明天可能会达到30.7摄氏度。";
              var _val = ((_value$match = value.match(/\d+\.\d+|\d+/g)) === null || _value$match === void 0 ? void 0 : _value$match.join('')) || '';
              _onChange === null || _onChange === void 0 || _onChange(e);
              setInputValue(_val);
            } else if (isValidInput) {
              _onChange === null || _onChange === void 0 || _onChange(e);
              setInputValue(value);
            }
            return;
          }
          _onChange === null || _onChange === void 0 || _onChange(e);
          setInputValue(value);
        },
        style: {
          background: 'transparent',
          outline: 'medium',
          caretColor: 'none',
          border: 'none',
          width: '100%'
        }
        // ADB1B8
        ,
        className: cn(fontSizeVariable[size], 'appearance-none placeholder:text-[#ADB1B8]', inputStyle, {
          'cursor-not-allowed bg-bds-input-disabled border-[#F3F5F7] text-base-bds-gray-t4-dis': props.disabled
        }),
        onFocus: function onFocus(evt) {
          setFocusStatus(true);
          _onFocus === null || _onFocus === void 0 || _onFocus(evt);
        },
        onPaste: function onPaste(e) {
          _onPaste === null || _onPaste === void 0 || _onPaste(e);
        },
        onKeyUp: function onKeyUp(e) {
          if (e.keyCode === 13 || e.which === 13) {
            onEnter === null || onEnter === void 0 || onEnter(inputValue);
          }
        }
      }, props), {}, {
        onBlur: function onBlur(e) {
          var _props$onBlur;
          if (type === 'number') {
            var _value = e.target.value;
            if (!_value) return;
            var parseToNumber = function parseToNumber(str) {
              // const parsedValue = parseFloat(str);
              var InputDecimal = decimalRef.current;
              var parsedValue = new InputDecimal(str);
              return parsedValue.toString();
            };
            var numberValue = parseToNumber(_value);
            var zeroCount = 0;
            if (firstZero) {
              var _value2 = e.target.value;
              if (_value2[0] === '0') {
                zeroCount = countNonZeros(_value2);
              }
            }
            if (zeroCount > 0 && firstZero && numberValue.toString()[0] !== '0') {
              var preZero = new Array(zeroCount).fill('0').join('');
              numberValue = preZero + numberValue;
              e.target.value = numberValue;
            } else {
              e.target.value = numberValue;
            }
            _onChange === null || _onChange === void 0 || _onChange(e);
            setInputValue(numberValue);
          }
          setFocusStatus(false);
          (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, e);
        }
      })), suffix && /*#__PURE__*/_jsxs(_Fragment, {
        children: [allowClear && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(EmptyIcon, {
            onClick: onClear,
            style: {
              color: 'var(--bds-gray-t2)'
            },
            className: cn('cursor-pointer', {
              'w-[16px] h-[16px]': ['small', 'xs'].includes(size),
              'w-[20px] h-[20px]': ['medium', 'x-large'].includes(size) || !size
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: cn('justify-items-center text-brandColor-bds-brand-900-text', fontSizeVariable[size]),
          style: {
            marginRight: type === 'number' && numberControl ? '8px' : '0px'
          },
          children: suffix
        })]
      }), (type === 'password' && visible || allowClear) && !suffix && /*#__PURE__*/_jsxs("div", {
        className: cn('flex items-center'),
        children: [allowClear && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(EmptyIcon, {
            onClick: onClear,
            style: {
              color: 'var(--bds-gray-t2)'
            },
            className: cn('cursor-pointer', {
              'w-[16px] h-[16px]': ['small', 'xs'].includes(size),
              'w-[20px] h-[20px]': ['medium', 'x-large'].includes(size) || !size
            })
          }), /*#__PURE__*/_jsx("div", {
            className: cn('border-colors-base-bds-gray-ele-border hidden mx-[8px] h-[18px] items-center', {
              block: type === 'password' && visible,
              'h-[16px] ': size === 'xs',
              'h-[18px] ': size === 'small',
              'h-[20px] ': size === 'medium',
              'h-[24px] ': size === 'x-large'
            }),
            style: {
              borderLeft: '1px solid var(--bds-gray-ele-border)'
            }
          })]
        }), type === 'password' && visible && /*#__PURE__*/_jsx(_Fragment, {
          children: passwordVisible ? /*#__PURE__*/_jsx(IconButton, {
            size: getIconSize(),
            children: /*#__PURE__*/_jsx(EyeonIcon, {
              onClick: function onClick() {
                setPasswordVisible(false);
                setInputType('password');
              }
            })
          }) : /*#__PURE__*/_jsx(IconButton, {
            size: getIconSize(),
            children: /*#__PURE__*/_jsx(EyeoffIcon, {
              onClick: function onClick() {
                setPasswordVisible(true);
                setInputType('text');
              }
            })
          })
        })]
      }), type === 'number' && numberControl && /*#__PURE__*/_jsxs("div", {
        className: cn('flex items-center'),
        children: [/*#__PURE__*/_jsx(IconButton, {
          size: getIconSize(),
          children: /*#__PURE__*/_jsx(ReduceIcon, {
            onClick: reduceHandler
          })
        }), /*#__PURE__*/_jsx("div", {
          className: cn('border-colors-base-bds-gray-ele-border mt-[2px] mx-[8px]  items-center', {
            'h-[16px] ': size === 'xs',
            'h-[18px] ': size === 'small',
            'h-[20px] ': size === 'medium',
            'h-[24px] ': size === 'x-large'
          }),
          style: {
            borderLeft: '1px solid var(--bds-gray-ele-border)'
          }
        }), /*#__PURE__*/_jsx(IconButton, {
          size: getIconSize(),
          children: /*#__PURE__*/_jsx(PlusIcon, {
            onClick: plusHandler
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: cn(inputVariants({
          variant: variant
        }), 'pl-[32px]'),
        style: {
          height: height,
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          pointerEvents: 'none'
        }
      })]
    })
  });
});
Input.displayName = 'Input';
export { Input, inputVariants };